export default "__VITE_ASSET__UYQku2FQ__"